export default __webpack_public_path__ + "static/media/map.bbecfccb.PNG";